/**
 * Raw traveler events emitted across RBC checkout flows
 * Used by flights, hotels, cars, packages, activities
 */

import type { ProductType } from "@b2bportal/core-types";

export enum TravelerRawEventName {
  ChooseTraveler = "ChooseTraveler",
}

export enum TravelerEventName {
  choose_traveler = "choose_traveler",
}

/**
 * Emitted when user selects a traveler for their booking
 */
export interface ChooseTravelerRawEvent {
  name: TravelerRawEventName.ChooseTraveler;
  properties: {
    product_type: ProductType | undefined;
  };
}

export interface ChooseTravelerEvent {
  name: TravelerEventName.choose_traveler;
  properties: {
    product_type: ProductType | undefined;
  };
}

export type TravelerRawEvent = ChooseTravelerRawEvent;

export type TravelerEvent = ChooseTravelerEvent;
